// SplashScreen.jsx — v119.214 iOS-style app launch splash (Thawany logo).
// Shows once per session on mobile / installed PWA, then fades out.
import React, { useEffect, useState } from "react";
import { zVar } from "./lib/zIndex";

const KEY = "tw-splash-shown";

const shouldShow = () => {
  if (sessionStorage.getItem(KEY)) return false;
  const standalone =
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true;
  return standalone || window.innerWidth < 768;
};

export default function SplashScreen() {
  const [phase, setPhase] = useState(() => (shouldShow() ? "in" : "gone"));

  useEffect(() => {
    if (phase === "gone") return;
    sessionStorage.setItem(KEY, "1");
    const t1 = setTimeout(() => setPhase("out"), 1400);
    const t2 = setTimeout(() => setPhase("gone"), 1950);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (phase === "gone") return null;

  return (
    <div data-testid="splash-screen"
         style={{
           position: "fixed", inset: 0, zIndex: zVar('extra_9999'),
           background: "linear-gradient(160deg, #3a2415 0%, #5c3a1e 55%, #4a2c1a 100%)",
           display: "flex", flexDirection: "column", alignItems: "center",
           justifyContent: "center", gap: 18,
           opacity: phase === "out" ? 0 : 1,
           transition: "opacity 0.55s ease",
           pointerEvents: phase === "out" ? "none" : "auto",
         }}>
      <div style={{
        width: 108, height: 108, borderRadius: 26, background: "#fff",
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
        animation: "tw-splash-pop 0.7s cubic-bezier(0.34,1.56,0.64,1) both",
      }}>
        <img src="/thawany-logo.png" alt="ثواني"
             style={{ width: 84, height: "auto" }} />
      </div>
      <div style={{
        color: "#D4AF37", fontSize: 15, fontWeight: 800, letterSpacing: 1,
        animation: "tw-splash-fade 0.9s ease 0.35s both",
      }}>
        ثواني · لوحة تحكم المقهى
      </div>
      <div style={{
        position: "absolute", bottom: 46, display: "flex", gap: 6,
        animation: "tw-splash-fade 0.9s ease 0.55s both",
      }}>
        {[0, 1, 2].map((i) => (
          <span key={i} style={{
            width: 6, height: 6, borderRadius: 999, background: "rgba(255,255,255,0.55)",
            animation: `tw-splash-dot 1s ease ${i * 0.18}s infinite alternate`,
          }} />
        ))}
      </div>
      <style>{`
        @keyframes tw-splash-pop { from { transform: scale(0.6); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        @keyframes tw-splash-fade { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes tw-splash-dot { from { opacity: 0.25; } to { opacity: 1; } }
      `}</style>
    </div>
  );
}
